import request from 'utils/request'
import { signIn, fetchAuthSession, signOut } from 'aws-amplify/auth'

export function login(data) {
  return request('auth', {
    method: 'POST',
    data
  }).then(([body]) => body)
}

export async function loginCognito(data) {
  try {
    // v6 signIn returns { isSignedIn, nextStep }; it throws on bad credentials.
    return await signIn({ username: data.email, password: data.password })
  } catch (error) {
    // Unlike v4, v6 signIn throws if a session is already cached. Clear it and
    // retry so a returning user (or a switched account) can sign in cleanly.
    if (error?.name === 'UserAlreadyAuthenticatedException') {
      try {
        await signOut()
        return await signIn({ username: data.email, password: data.password })
      } catch (retryError) {
        return retryError
      }
    }

    return error
  }
}

export async function getCognitoSession() {
  try {
    // v6 returns { tokens: { accessToken, idToken } }, or no tokens when signed out.
    const { tokens } = await fetchAuthSession()

    return tokens || false
  } catch (error) {
    return false
  }
}

export async function logoutCognito() {
  try {
    await signOut()
  } catch (err) {}
}
